// material
// components
import Page from '../components/configs/Page';

import {
  Stack,
  Container,
  Typography
} from '@mui/material';
// ----------------------------------------------------------------------

export default function Mensagens() {
  return (
    <Page title="INPACT | Mensagens">
      <Container maxWidth="xl">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h3" gutterBottom>
                    Mensagens
                </Typography>
            </Stack>
            <Typography variant="body1" sx={{textAlign: "left"}}>
                    Funcionalidade em desenvolvimento...
                </Typography>
        </Container>
    </Page>
  );
}
